import React from 'react'
import { EditOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import CommunicationBasicDetail from "./CommunicationComponents/CommunicationBasicDetail";

import { CommunicationDetailContext, useCommunicationDetailContext } from "contexts/CommunicationDetailContext";

import { useGetCommunicationDetailQuery, useUpdateCommunicationMutation } from "store/services/communicationApi";


const CommunicationDetailScreen = () => {

  const { id } = useParams();

  const breadcrumb = [
    { title: "Communication", path: "/app/crm/communication/list" },
    { title: "Communication Detail" }
  ]

  // RTK Query
  const {
    data: communicationDetail,
    isLoading: loadingCommunication,
    error,
  } = useGetCommunicationDetailQuery(id);

  return (
    <CommunicationDetailContext.Provider value={{ communicationDetail, loadingCommunication }}>
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingCommunication}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <CommunicationBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </CommunicationDetailContext.Provider>
  )
}

export default CommunicationDetailScreen;


const PageActions = () => {
  const { communicationDetail, loadingCommunication }
    = useCommunicationDetailContext();

  // RTK Query
  const [updateCommunication, { isLoading: updatingCommunication }]
    = useUpdateCommunicationMutation();

  // methods
  const handelToggleCrossDockingStatus = async () => {
    try {
      await updateCommunication({
        _id: communicationDetail._id,
        isActive: !communicationDetail.isActive,
      }).unwrap();
      toast.info(`CrossDocking ${communicationDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <div className="flex space-x-4">
      <EnableDisableButton
        isActive={communicationDetail?.isActive}
        loading={loadingCommunication || updatingCommunication}
        onClick={handelToggleCrossDockingStatus}
      />
      <Link to={`/app/crm/communication/${communicationDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};